import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=2ab1aba1&scoped=true"
import script from "./SelectableCard.vue?vue&type=script&lang=js"
export * from "./SelectableCard.vue?vue&type=script&lang=js"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=2ab1aba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1aba1",
  null
  
)

export default component.exports